import * as MARKETviewApi from 'api/market-view-api';
import * as StrapiApi from 'api/strapi-api';

const apiBundle = {
  ...MARKETviewApi,
  ...StrapiApi,
};

export type ApiBundle = typeof apiBundle;

export default apiBundle;
